import { SatellitePage } from "../SatellitePage";
import Sliderx from "../../utils/Sliderx";

export default class PricesSatellitePage extends SatellitePage {
    private slider: Sliderx;

    public onInit(): void {
        this.slider = new Sliderx($('.sliderx', this.$el));
    }
}
